import React from 'react'
import Value from '../../../molecules/Value'
import PublishScheduleRangeField from '../../../molecules/fields/PublishScheduleRangeField'
import FieldCheckboxTitle from '../../../molecules/FieldCheckboxTitle'
import { useField } from 'react-final-form'

const name = 'has_published_schedule'
const PublishSchedule = () => {
  const { input: destroyPublishInput } = useField(`publish._destroy`)
  const { input: destroyUnpublishInput } = useField(`unpublish._destroy`)

  const handlePublishCheckChange = value => {
    if (value) {
      destroyPublishInput.onChange(undefined)
      destroyUnpublishInput.onChange(undefined)
    } else {
      destroyPublishInput.onChange(true)
      destroyUnpublishInput.onChange(true)
    }
  }

  return (
    <div>
      <FieldCheckboxTitle
        name={name}
        label="Publicación y despublicación del formulario"
        description="El formulario se publicará y/o despublicará en la fecha y hora seleccionada."
        onChange={handlePublishCheckChange}
      />
      <Value name="has_published_schedule">
        {({ value: hasScheduleValue }) => hasScheduleValue && <PublishScheduleRangeField />}
      </Value>
    </div>
  )
}

export default PublishSchedule
